import { render, staticRenderFns } from "./brl.vue?vue&type=template&id=6d6c1d53&"
import script from "./brl.vue?vue&type=script&lang=js&"
export * from "./brl.vue?vue&type=script&lang=js&"
import style0 from "./brl.vue?vue&type=style&index=0&id=6d6c1d53&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports